/* FMX Search: isolated predictive-search presentation and request handling. */
(()=>{
  'use strict';
  const overlay=document.querySelector('[data-search-overlay]');
  const input=overlay?.querySelector('[data-predictive-input]');
  const results=overlay?.querySelector('[data-predictive-results]');
  if(!overlay||!input||!results||overlay.dataset.fmxSearchReady)return;
  overlay.dataset.fmxSearchReady='true';
  const routes=window.FMX?.routes||{};
  const searchRoute=routes.search||'/search';
  const allRoute=routes.allProducts||'/collections/all';
  const predictiveRoute=routes.predictive||'/search/suggest';
  const currency=window.FMX?.currency||'USD';
  const normalizePriceValue=value=>{
    if(value===null||value===undefined||value==='')return null;
    const raw=String(value).trim();
    if(!raw)return null;
    const cleaned=raw.replace(/[^0-9,.-]/g,'').replace(/,(?=\d{1,2}$)/,'.');
    const n=Number(cleaned);
    if(!Number.isFinite(n))return null;
    const hasDecimal=/[.,]\d{1,2}$/.test(cleaned);
    if(hasDecimal)return n;
    return Math.abs(n)>=1000 ? n/100 : n;
  };
  const formatPrice=value=>{
    const amount=normalizePriceValue(value);
    if(!Number.isFinite(amount))return '';
    try{return new Intl.NumberFormat(document.documentElement.lang||'es',{style:'currency',currency}).format(amount)}
    catch(e){return '$'+amount.toFixed(2)}
  };
  const element=(tag,cls,text)=>{const el=document.createElement(tag);if(cls)el.className=cls;if(text!==undefined)el.textContent=text;return el};
  const link=(text,url,cls)=>{const a=element('a',cls,text);a.href=url;return a};
  const safeUrl=url=>{try{const u=new URL(url,location.origin);return u.origin===location.origin?u.href:'#'}catch(e){return '#'}};
  const setResults=(...nodes)=>{results.replaceChildren(...nodes)};
  const allLink=q=>link('VER TODOS LOS RESULTADOS →',searchRoute+'?q='+encodeURIComponent(q),'btn btn--outline');
  const empty=(q,failed=false)=>{
    const box=element('div','fmx-search-empty');
    box.append(element('span','fmx-search-empty__eyebrow',failed?'BÚSQUEDA NO DISPONIBLE':'SIN RESULTADOS'));
    box.append(element('h3','fmx-search-empty__title',failed?'NO PUDIMOS COMPLETAR LA BÚSQUEDA':'NO ENCONTRAMOS RESULTADOS'));
    box.append(element('p','fmx-search-empty__copy',failed?'Intenta nuevamente o explora el catálogo.':'No encontramos coincidencias para “'+q+'”. Prueba con otra palabra o explora el catálogo.'));
    const actions=element('div','fmx-search-empty__actions');
    actions.append(allLink(q),link('IR A SHOP →',allRoute,'btn btn--outline'));
    box.append(actions);
    setResults(box);
  };
  const render=(data,q)=>{
    const r=data?.resources?.results||{};
    const products=Array.isArray(r.products)?r.products:[];
    const other=[...(r.collections||[]),...(r.pages||[]),...(r.articles||[])];
    if(!products.length&&!other.length){empty(q);return}
    const fragment=document.createDocumentFragment();
    if(products.length){
      const group=element('section','predictive-group fmx-search-products');
      group.append(element('h3','','PRODUCTOS'));
      const grid=element('div','predictive-grid');
      products.forEach(p=>{
        const price=formatPrice(p.price);
        const card=link(undefined,safeUrl(p.url),'predictive-item fmx-search-product');
        card.setAttribute('aria-label','Ver '+p.title+(price?', '+price:''));
        const media=element('span','fmx-search-product__media');
        if(p.image){const img=element('img');img.src=p.image;img.alt=p.title;img.loading='lazy';img.decoding='async';media.append(img)}
        card.append(media);
        card.append(element('strong','fmx-search-product__title',p.title));
        const footer=element('span','fmx-search-product__footer');
        const badge=element('span','fmx-search-product__price');
        badge.append(element('span','fmx-search-product__amount',price));
        const buy=element('span','fmx-search-product__buy','COMPRAR →');
        footer.append(badge,buy);
        card.append(footer);
        grid.append(card);
      });
      group.append(grid);fragment.append(group);
    }
    if(other.length){
      const group=element('section','predictive-group fmx-search-more');group.append(element('h3','','MÁS RESULTADOS'));
      const links=element('div','predictive-links');
      other.forEach(item=>links.append(link(item.title,safeUrl(item.url),'fmx-search-more__link')));
      group.append(links);fragment.append(group);
    }
    const all=element('div','predictive-all');all.append(allLink(q));fragment.append(all);
    setResults(fragment);
  };
  let timer,controller,sequence=0;
  const update=()=>{
    clearTimeout(timer);controller?.abort();const id=++sequence;const q=input.value.trim();
    if(q.length<2){setResults(element('p','muted',q?'Escribe al menos 2 caracteres.':'Escribe para buscar en FMX.'));return}
    timer=setTimeout(async()=>{
      controller=new AbortController();
      setResults(element('p','muted','Buscando…'));
      try{
        const url=new URL(predictiveRoute+'.json',location.origin);
        url.searchParams.set('q',q);
        url.searchParams.set('resources[type]','product,collection,page,article');
        url.searchParams.set('resources[limit]','6');
        url.searchParams.set('resources[options][unavailable_products]','last');
        const response=await fetch(url,{headers:{Accept:'application/json'},signal:controller.signal});
        if(!response.ok)throw new Error('Search request failed');
        const data=await response.json();if(id===sequence)render(data,q);
      }catch(e){if(e.name!=='AbortError'&&id===sequence)empty(q,true)}
    },220);
  };
  input.addEventListener('input',update);
  overlay.querySelector('form')?.addEventListener('submit',()=>{clearTimeout(timer);controller?.abort()});
  // Refresh results when the editor opens Search with an existing query.
  overlay.addEventListener('fmx-search-open',()=>{if(input.value.trim().length>=2)update()});
  if(input.value.trim().length>=2)update();
  window.FMXSearch={render,empty,update};
})();
